import React, { useState, useEffect, useRef, useMemo } from "react";
import JoditEditor from "jodit-react";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import axios from "axios";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import AdminImageUploadZone from "../../../../components/CommonComponents/AdminImageUploadZone";
import Defaultloadinggif from "../../../../layout/Others/Defaultloadinggif";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";

function Loginpage_Setting() {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext()
  const baseURL = process.env.REACT_APP_Baseurl
  const indexApi = `${baseURL}/admin/setting/index`
  const storeApi = `${baseURL}/admin/setting/store`
  const imageApi = globalImageUplaodAPI()
  const uploadHeaders = {
    Authorization: "Bearer " + (localStorage.getItem("access_token") || ""),
    Accept: "application/json",
  }

  const [formData, setFormData] = useState()
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [formDataError, setFormDataError] = useState({})
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);
  const [loginImage, setLoginImage] = useState("")
  const [notificationImage, setNotificationImage] = useState("")
  const [emailImage, setEmailImage] = useState("")
  const [loading, setLoading] = useState("");
  const [timeoutDays, setTimeoutDays] = useState(0)
  const [timeoutHours, setTimeoutHours] = useState(24)
  const [timeoutMins, setTimeoutMins] = useState(0)

  const combinedRef = useRef({});
  const joditConfig = useMemo(() => ({
    readonly: false,
    placeholder: 'Start typing here...',
    height: 350,
    maxHeight: 500,
    autobheight: false,
    toolbarSticky: true,
    width: '100%',
  }), []);

  // Convert minutes to days, hours, and minutes
  const convertMinutesToTime = (totalMinutes) => {
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;
    return { days, hours, minutes };
  };

  // Convert days, hours, and minutes to total minutes
  const convertTimeToMinutes = (days, hours, minutes) => {
    return (parseInt(days) || 0) * 1440 + (parseInt(hours) || 0) * 60 + (parseInt(minutes) || 0);
  };

  const handleInput = async (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'text' || type === 'textarea') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handleTimeoutChange = (type, value) => {
    const numValue = Math.max(0, parseInt(value) || 0);

    if (type === 'days') {
      setTimeoutDays(numValue);
    } else if (type === 'hours') {
      setTimeoutHours(Math.min(23, numValue)); // Max 23 hours
    } else if (type === 'minutes') {
      setTimeoutMins(Math.min(59, numValue)); // Max 59 minutes
    }

    // Clear any previous timeout error
    setFormDataError((prev) => ({
      ...prev,
      login_timeout: '',
    }));
  };

  const handleUpdate = async () => {
    setShowOverlay(true);

    // Validate timeout - at least one field must be greater than 0
    const totalMinutes = convertTimeToMinutes(timeoutDays, timeoutHours, timeoutMins);
    if (totalMinutes === 0) {
      setFormDataError((prev) => ({
        ...prev,
        login_timeout: 'Login timeout must be greater than 0 minutes',
      }));
      setShowOverlay(false);
      return;
    }

    const formDataAdd = {};
    for (const key in formData) {
      if (["login_text", "login_text_status", "notification_key", "signature", "show_login_message", "login_form_position", "login_description"].includes(key)) {
        formDataAdd[key] = formData[key]
      }
    }

    // Ensure login_form_position is always sent with a value
    if (!formDataAdd.login_form_position) {
      formDataAdd.login_form_position = formData?.login_form_position || 'left';
    }

    // Add login_timeout in minutes
    formDataAdd.login_timeout = totalMinutes;
    const reponse = await fetchRequest({
      method: 'POST',
      url: `${storeApi}`,
      params: {},
      data: formDataAdd,
    })
      .then(response => {
        if (response?.status) {
          if (notificationImage || emailImage || loginImage) {
            handleFileUpload()
          }
        }
      }).catch((error => {
        toast.error(error?.response?.data?.message)
      })).finally(() => {
        setShowOverlay(false)
        setWithOutRefresh((prev) => !prev)
      })

  }

  const handleFileUpload = async () => {
    setShowOverlay(true)
    try {
      const formDataAdd = new FormData();
      const imageFields = [];
      const modelName = "Setting";
      const settingId = formData?.id;
      if (!settingId) {
        throw new Error("Missing settings id for image upload");
      }
      formDataAdd.append('id', settingId)
      formDataAdd.append('modelName', modelName)

      if (loginImage) {
        formDataAdd.append('login_content', loginImage)
        imageFields.push('login_content')
      }
      if (notificationImage) {
        formDataAdd.append('notification_icon', notificationImage)
        imageFields.push('notification_icon')
      }
      if (emailImage) {
        formDataAdd.append('email_image', emailImage)
        imageFields.push('email_image')
      }

      if (imageFields.length > 0) {
        imageFields.forEach((field) => formDataAdd.append('imageFields[]', field))
        const response = await fetchRequest({
          method: 'POST',
          url: imageApi,
          data: formDataAdd,
        });
        const result = response?.data;
        if (result?.status) {
          setLoginImage(null)
          setNotificationImage(null)
          setEmailImage(null)
        } else {
          toast.error(result?.message || 'Failed to upload images')
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message)
    }
    finally {
      setShowOverlay(false)
      setWithOutRefresh((prev) => !prev)
    }
  }
  const handleFileChange = async (event) => {
    const { files, name } = event.target;
    setFormDataError((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (files?.length > 0) {
      const newFile = files[0];
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

      // Check if the file type is allowed
      if (!allowedTypes.includes(newFile.type)) {
        setFormDataError((prev) => ({
          ...prev,
          [name]: "Only JPEG, JPG, and PNG , WEBP images are allowed.",
        }));
        return; // Exit if file type is not allowed
      }

      const reader = new FileReader();
      const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onloadend = () => resolve(reader.result); // Fallback
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };

      try {
        const fileContent = await readFile(newFile);

        if (name === 'login') {
          setLoginImage(newFile);
        } else if (name === 'notification') {
          setNotificationImage(newFile);
        } else if (name === 'email') {
          setEmailImage(newFile);
        }
      } catch (error) {
        toast.error("Failed to read the file.");
      }
    }
  };

  const handleClearSelectFile = (value) => {
    if (value == 'login') {
      setLoginImage(null);
    }
    if (value == 'notification') {
      setNotificationImage(null);
    };
    if (value == 'email') {
      setEmailImage(null);
    };
  }

  // Populate timeout fields when formData changes
  useEffect(() => {
    if (formData?.login_timeout) {
      const timeBreakdown = convertMinutesToTime(formData.login_timeout);
      setTimeoutDays(timeBreakdown.days);
      setTimeoutHours(timeBreakdown.hours);
      setTimeoutMins(timeBreakdown.minutes);
    }
  }, [formData?.login_timeout]);

  useEffect(async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${indexApi}`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          setFormData((prev) => ({
            ...prev,
            ...response?.setting
          }));
        }
      }).catch((error => {
        toast.error(error?.response?.data?.message)
      })).finally(() => {
        setLoading(false)
      })
  }, [withOutRefresh]);

  if (loading) {
    return <Defaultloadinggif className={"heightOnLoader"} />
  }
  return (
    <>
      {showOverlay && (<Response_Processing />)}

      <AdminBackNavigation text="Back" path="/settings" />
      <AdminSaveHeader heading={"Login Page Settings"} saveText={"Update"} saveMethod={handleUpdate} loading={showOverlay} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Create Login Page" />
            <MessageLabel text="Login Timeout" />
            <div className="d-flex gap-2 mb-3">
              <div className="flex-fill">
                <label className="form-label small">Days</label>
                <input
                  type="number"
                  className="form-control"
                  value={timeoutDays}
                  onChange={(e) => handleTimeoutChange('days', e.target.value)}
                  min="0"
                  max="365"
                  placeholder="Days"
                />
              </div>
              <div className="flex-fill">
                <label className="form-label small">Hours</label>
                <input
                  type="number"
                  className="form-control"
                  value={timeoutHours}
                  onChange={(e) => handleTimeoutChange('hours', e.target.value)}
                  min="0"
                  max="23"
                  placeholder="Hours"
                />
              </div>
              <div className="flex-fill">
                <label className="form-label small">Minutes</label>
                <input
                  type="number"
                  className="form-control"
                  value={timeoutMins}
                  onChange={(e) => handleTimeoutChange('minutes', e.target.value)}
                  min="0"
                  max="59"
                  placeholder="Minutes"
                />
              </div>
            </div>
            {formDataError?.login_timeout && (
              <div className="text-danger small mb-2">{formDataError.login_timeout}</div>
            )}

            <MessageLabel text="Pusher Notification" />
            <AdminCustomInput type="text" name="notification_key" value={formData?.notification_key} ref={(el) => (combinedRef.current.notification_key = el)} onChange={handleInput} placeHolder={"notification key"} error={formDataError?.notification_key} />
            <MessageLabel text="Email Signature" />
            <JoditEditor
              className="mb-3"
              config={joditConfig}
              ref={(el) => (combinedRef.current.signature = el)}
              value={formData?.signature}
              onChange={(newContent) => setFormData(prev => ({ ...prev, signature: newContent }))}
            />
          </Wrapper>
          <Wrapper>
            <MessageHeading text=" Login Page Content" />
            <div className="d-flex align-items-center gap-2">
              <MessageLabel text="Show Login Message" />
              <AdminSwitch
                name="show_login_message"
                checked={formData?.show_login_message === 1}
                onChange={(e) => setFormData(prev => ({ ...prev, show_login_message: e.target.checked ? 1 : 0 }))}
              />
            </div>

            <MessageLabel text="Login Form Position" />
            <div className="d-flex gap-2 mb-3">
              <button
                type="button"
                className={`btn btn-sm ${(formData?.login_form_position ?? 'right') === 'left' ? 'btn-primary' : 'btn-outline-secondary'}`}
                onClick={() => setFormData(prev => ({ ...prev, login_form_position: 'left' }))}
              >
                <i className="fa fa-align-left me-1"></i> Left
              </button>
              <button
                type="button"
                className={`btn btn-sm ${(formData?.login_form_position ?? 'right') === 'right' ? 'btn-primary' : 'btn-outline-secondary'}`}
                onClick={() => setFormData(prev => ({ ...prev, login_form_position: 'right' }))}
              >
                Right <i className="fa fa-align-right ms-1"></i>
              </button>
            </div>

            <MessageLabel text="Login Description" />
            <JoditEditor
              className="mb-3"
              config={joditConfig}
              ref={(el) => (combinedRef.current.login_description = el)}
              value={formData?.login_description || ''}
              onChange={(newContent) => setFormData(prev => ({ ...prev, login_description: newContent }))}
            />

            <MessageLabel text="Login Text" />
            <AdminCustomInput type="text" name="login_text" value={formData?.login_text} ref={(el) => (combinedRef.current.login_text = el)} onChange={handleInput} placeHolder={"login text"} error={formDataError?.login_text} />

            <div className="d-flex align-items-center gap-2 mt-3 mb-2">
              <MessageLabel text="Login Text Status" />
              <AdminSwitch
                name="login_text_status"
                checked={Number(formData?.login_text_status) === 1}
                onChange={(e) => setFormData(prev => ({ ...prev, login_text_status: e.target.checked ? 1 : 0 }))}
              />
            </div>

          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text="Thumbnails" />
            <MessageLabel text="Login Page Content" />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={loginImage}
              uploadedImage={formData?.login_content}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.login = el)}
              name="login"
              id={formData}
              error={formDataError?.login}
            />
            <MessageLabel text="Notification Icon" />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={notificationImage}
              uploadedImage={formData?.notification_icon}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.notification = el)}
              name="notification"
              id={formData}
              error={formDataError?.notification}
            />
            <MessageLabel text="Email Image" />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={emailImage}
              uploadedImage={formData?.email_image}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.email = el)}
              name="email"
              id={formData}
              error={formDataError?.email}
            />
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleUpdate} saveText={"Update"} loading={showOverlay} />
      </FormContainer>
    </>
  );
}

export default Loginpage_Setting;
